import React, { useState } from 'react';
import * as Styled from './styles';
import {
  DITablet,
  TariffsBlockContainer,
  TariffsBlockDescItem,
  TariffsBlockDescription,
  TariffsBlockHeader,
  TariffsBlockSelect,
  TariffsBlockSettings,
  TariffsBlockTariffs,
  TariffsBlockWrap,
  TBCard,
  TBCardDescItem,
  TBCardDescription,
  TBCardHeader, TBCardOrder,
  TBCardPriceCurrent,
  TBCardPriceOld,
  TBCardTitle
} from "../../components/tariffs-block";
import Select from "../../components/select";
import Switcher from "../../components/switcher";
import { Button, ButtonFilter } from "../../components/button";
import discount from './discount.svg';
import { SvgCross, SvgInfinite, SvgSettings } from "../../components/svgIcon";
import SlideDown from "react-slidedown/lib/slidedown";
import ESlider, { EmblaSlide } from "../../components/embla-slider";
import { hostingTariffs } from '../../data/hosting-tariffs';
import plural from "../../utils/plural";
import { yandexReachGoal } from '../../utils/yandexReachGoal/yandexReachGoal';

const switchControls = [
  { title: 'Недорогие', val: 'hdd' },
  { title: 'Быстрые', val: 'ssd' }
];

const selectOptions = [
  { title: '1 месяц', val: 1 },
  { title: '3 месяца', val: 3 },
  { title: '6 месяцев', val: 6 },
  { title: () => <>12 месяцев &nbsp;&nbsp; <img src={discount} alt="" /></>, val: 12 },
  { title: () => <>24 месяца &nbsp;&nbsp; <img src={discount} alt="" /></>, val: 24 }
];

const HostingTariffs = (props) => {
  const [switched, setSwitched] = useState(switchControls[0]);
  const [period, setPeriod] = useState(selectOptions[3]);
  const [showPeriodMobile, setShowPeriodMobile] = useState(false);

  const changeTypeHosting = type => setSwitched(type);
  const changePeriod = period => setPeriod(period);

  return (
    <TariffsBlockWrap>
      <TariffsBlockHeader>
        <h1>Аренда хостинга для сайта</h1>

        <TariffsBlockSettings>
          <Styled.TariffsBlockSettingsIcon show={showPeriodMobile} onClick={() => setShowPeriodMobile(!showPeriodMobile)}>
            <SvgSettings />
          </Styled.TariffsBlockSettingsIcon>

          <Styled.TariffsBlockSwitcher>
            <Switcher controls={switchControls} switchedControl={switched} onChange={changeTypeHosting} />
          </Styled.TariffsBlockSwitcher>

          <Styled.TariffsBlockSwitcherButtons>
            <ButtonFilter onClick={() => changeTypeHosting(switchControls[0])}
              active={switched.val === switchControls[0].val}
            >{switchControls[0].title}</ButtonFilter>

            <ButtonFilter onClick={() => changeTypeHosting(switchControls[1])}
              active={switched.val === switchControls[1].val}
            >{switchControls[1].title}</ButtonFilter>
          </Styled.TariffsBlockSwitcherButtons>

          <TariffsBlockSelect>
            <p>При покупке на</p>
            <Select options={selectOptions} selected={period} onChange={changePeriod} />
          </TariffsBlockSelect>
        </TariffsBlockSettings>

        <Styled.TariffsBlockSelectButtons>
          <SlideDown>
            {showPeriodMobile && <ESlider>
              {[...selectOptions].reverse().map(el => <EmblaSlide>
                <ButtonFilter onClick={() => changePeriod(el)}
                  active={el.val === period.val}
                >{typeof el.title === 'function' ? el.title() : el.title}</ButtonFilter>
              </EmblaSlide>)}
            </ESlider>}
          </SlideDown>
        </Styled.TariffsBlockSelectButtons>
      </TariffsBlockHeader>

      <TariffsBlockContainer>
        <TariffsBlockDescription>
          <TariffsBlockDescItem>Дисковое пространство, Гб</TariffsBlockDescItem>
          <TariffsBlockDescItem>Размещенных доменов</TariffsBlockDescItem>
          <TariffsBlockDescItem>Количество сайтов</TariffsBlockDescItem>
          <TariffsBlockDescItem>Базы данных MySQL	</TariffsBlockDescItem>
          <TariffsBlockDescItem>Почтовые ящики</TariffsBlockDescItem>
          <TariffsBlockDescItem>Ограничение памяти на PHP</TariffsBlockDescItem>
          <TariffsBlockDescItem>Поддержка версий PHP</TariffsBlockDescItem>
        </TariffsBlockDescription>

        <TariffsBlockTariffs>
          <ESlider>
            {hostingTariffs
              .filter(el => el.type === switched.val)
              .map(tariff => {
                const pricePeriod = tariff.priceList.find(el => el.period === period.val);
                const priceMonth = pricePeriod.val / pricePeriod.period;
                const priceOld = priceMonth !== tariff.price && tariff.price;

                return <TBCard key={tariff.id}>
                  <TBCardHeader>
                    <TBCardTitle>{tariff.name}</TBCardTitle>
                    <TBCardPriceOld>{priceOld ? `${priceOld} ₽` : ''}</TBCardPriceOld>
                    <TBCardPriceCurrent>{priceMonth} ₽</TBCardPriceCurrent>
                  </TBCardHeader>

                  <TBCardDescription>
                    <TBCardDescItem>
                      {tariff.properties.disk}&nbsp;<DITablet>Гб {switched.val.toUpperCase()}</DITablet>
                    </TBCardDescItem>
                    <TBCardDescItem>
                      {tariff.properties.domains === '∞' ? <SvgInfinite /> : `до ${tariff.properties.domains}`}
                      &nbsp;<DITablet>{plural(tariff.properties.domains, ['домена', 'доменов', 'доменов'])}</DITablet>
                    </TBCardDescItem>
                    <TBCardDescItem>
                      {tariff.properties.sites === '∞' ? <SvgInfinite /> : tariff.properties.sites}
                      &nbsp;<DITablet>{plural(tariff.properties.sites, ['сайт', 'сайта', 'сайтов'])}</DITablet>
                    </TBCardDescItem>
                    <TBCardDescItem>
                      {tariff.properties.db === '∞' ? <SvgInfinite /> : tariff.properties.db}
                      &nbsp;<DITablet>БД MySQL</DITablet>
                    </TBCardDescItem>
                    <TBCardDescItem>
                      {tariff.properties.mail === 'none' && <SvgCross />}
                      {tariff.properties.mail === '∞' && <SvgInfinite />}
                      {tariff.properties.mail !== '∞' && tariff.properties.mail !== 'none' && tariff.properties.mail}
                      &nbsp;<DITablet>почтовых ящиков</DITablet>
                    </TBCardDescItem>
                    <TBCardDescItem>
                      <DITablet>PHP memory limit&nbsp;</DITablet>{tariff.properties.limit}&nbsp;<DITablet>Mb</DITablet>
                    </TBCardDescItem>
                    <TBCardDescItem>
                      <DITablet>PHP v.&nbsp;</DITablet> {tariff.properties.php}
                    </TBCardDescItem>
                  </TBCardDescription>

                  <TBCardOrder>
                    <Button onClick={() => {
                      yandexReachGoal('buy-hosting');
                      window.location.href = 'https://cp.hostline.ru/'
                    }}>Заказать</Button>
                  </TBCardOrder>
                </TBCard>
              })
            }
          </ESlider>
        </TariffsBlockTariffs>
      </TariffsBlockContainer>
    </TariffsBlockWrap>
  )
}

export default HostingTariffs
